enum CreationMethodEnum {
    Auto = 'AUTO',
}

export default CreationMethodEnum;
